import React, { FC } from 'react';
import { Container, Paragraph, LoadingBar } from './styles';
import logoGerdauNew from '../../assets/images/logo_gerdau_new.svg';

const LoaderBox: FC = () => {
  return (
    <Container>
      <div>
        <Paragraph>
          <small>Por favor, aguarde</small>
        </Paragraph>

        <img src={logoGerdauNew} alt="Gerdau" />

        <LoadingBar>
          <div></div>
        </LoadingBar>

        <Paragraph>
          <small>Estamos carregando os dados</small>
        </Paragraph>
      </div>
    </Container>
  );
};

export default LoaderBox;
